export default __webpack_public_path__ + "static/media/078-statue.c41c6e87.svg";